/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：汎用定義サービス
 *
 * 作成者：2022/1/10 ノア）黄
 * 最終修正者：2022/1/10 ノア）黄
 *
 */
import { General, GeneralRequestParam } from '@/models'
import { setSessionStorage, getSessionStorage } from '@/utils/localStorageUtils'
import { getGeneralData } from '@/store/apis'

/**
 * 汎用定義
 *
 * @readonly
 * @constant
 */
export enum GeneralType {
  /**
   * メッセージ送信タイプ
   */
  MESSAGE_SEND_TYPE = 'MESSAGE_SEND_TYPE',

  /**
   * アナウンスタイプ
   */
  ANNOUNCE_TYPE = 'ANNOUNCE_TYPE',

  /**
   * 送信状況
   */
  SEND_STATUS = 'SEND_STATUS',

  /**
   * ユーザ種類
   */
  USER_ROLE = 'USER_ROLE',

  /**
   * 管理場所種類
   */
  PLACE_TYPE = 'PLACE_TYPE',

  /**
   * 稼働状況
   */
  DEVICE_STATUS = 'DEVICE_STATUS',

  /**
   * 利用状況
   */
  USAGE_STATUS = 'USAGE_STATUS',

  /**
   * 加速度検知閾値レンジ
   */
  THRESHOLD_RANGE = 'THRESHOLD_RANGE',

  /**
   * 加速度検知モード
   */
  ACTIVE_DETECTION_MODE = 'ACTIVE_DETECTION_MODE',

  /**
   * 通知タイプ
   */
  NOTIFICATIONS_TYPE = 'NOTIFICATIONS_TYPE',

  /**
   * 入出区分
   */
  ARRIVAL_STATUS = 'ARRIVAL_STATUS',

  /**
   * 節電モード
   */
  POWER_SAVING_MODE = 'POWER_SAVING_MODE',

  /**
   * 帳票選択モード
   */
  BILL_SELECT_MODE = 'BILL_SELECT_MODE'
}

const general = {
  [GeneralType.MESSAGE_SEND_TYPE]: [] as General[], // メッセージ送信タイプ
  [GeneralType.ANNOUNCE_TYPE]: [] as General[], // アナウンスタイプ
  [GeneralType.SEND_STATUS]: [] as General[], // 送信状況
  [GeneralType.USER_ROLE]: [] as General[], // ユーザ種類
  [GeneralType.PLACE_TYPE]: [] as General[], // 管理場所種類
  [GeneralType.DEVICE_STATUS]: [] as General[], // 稼働状況
  [GeneralType.USAGE_STATUS]: [] as General[], // 利用状況
  [GeneralType.THRESHOLD_RANGE]: [] as General[], // 加速度検知閾値レンジ
  [GeneralType.NOTIFICATIONS_TYPE]: [] as General[], // 通知タイプ
  [GeneralType.ARRIVAL_STATUS]: [] as General[], // 入出区分タイプ
  [GeneralType.POWER_SAVING_MODE]: [] as General[], // 節電モード
  [GeneralType.ACTIVE_DETECTION_MODE]: [] as General[], // 加速度検知モード
  [GeneralType.BILL_SELECT_MODE]: [] as General[] // 帳票選択モード
}

export const generalService = new Proxy(general, {
  async get(target, key) {
    const value = getSessionStorage(key as string)
    if (value && value.length > 0) {
      return value
    }

    const generalRequestParam = {
      codeTypeList: [key as string]
    } as GeneralRequestParam

    const res = await getGeneralData(generalRequestParam)

    if (res && res[key as string]) {
      setSessionStorage(key as string, res[key as string])
      Reflect.set(target, key, res[key as string])
      return res[key as string]
    }

    return []
  }
})
